<template>
  <div class="repay-result">
    <!-- 只是为了兼容在APP内的情况 -->
    <navigation adaption/>
    <pulldown-page :refresh="pulldown" background="white" color="#333333">
      <div class="pull">
        <common :index="2"/>
        <div class='repay-status'>
          <div class="animation-wapper" v-if="showGif">
            <lottie ref="animataion" :options="showGif"  v-on:animCreated="handleAnimation"/>
          </div>
          <p class="status-title">{{ showDetail.name }}</p>
          <div class="status-description">
            <p v-for="(des, index) in showDetail.des" :key="index">{{ des }}</p>
          </div>
          <template v-if="showDetail.showList">
            <div class="bill-info" >
              <div class="item">
                <p class="title">还款金额</p>
                <p class="content">￥{{ repaymentBill.repaymentAmount | currency }}</p>
              </div>
              <div class="item">
                <p class="title">还款日期</p>
                <p class="content">{{ repaymentBill.repaymentDate | date}}</p>
              </div>
              <div class="item">
                <p  class="title">还款平台</p>
                <p  class="content">{{repaymentBill.repaymentPlatform}}</p>
              </div >
            </div>
            <div class="bill-info">
              <div class="item">
                <p class="title">新增借款</p>
                <p class="content">￥{{ loanBill.loanAmount | currency }}</p>
              </div>
              <div class="item">
                <p class="title">借款期限</p>
                <p class="content">{{ loanBill.loanTermNo}}</p>
              </div>
              <div class="item">
                <p class="title">借款日期</p>
                <p class="content">{{ loanBill.loanDate | date}}</p>
              </div>
              <div class="item">
                <p  class="title">借款平台</p>
                <p  class="content">{{loanBill.loanPlatform}}</p>
              </div >
            </div>
          </template>
          <div class="call" @click="openCallDialog" v-if="showDetail.showIphone">
            <img src="../../../assets/images/call.png"/>
            <span>联系客服</span>
          </div>
          <nd-button class="btn" @click="back" v-show="showDetail.buttonTitle">{{ showDetail.buttonTitle }}</nd-button>
        </div>
        <img
          class="xia-zai"
          src="./images/xiazai02.png"
          srcset="
                        ./images/xiazai02@2x.png,
                        ./images/xiazai02@3x.png
                    "
          @click="startLeading"
        />
      </div>
    </pulldown-page>
    <!-- 联系客服弹窗框 -->
    <nd-dialog v-model="serviceVisible" @confirm="callService" @close="closeDialog">
      <div class="service-dialog">
        <div class="title">联系客服</div>
        <div class="description">拨打客服电话进行咨询</div>
        <div class="description1">客服电话：4000100008</div>
        <div class="telphone">服务时间：</div>
        <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
      </div>
    </nd-dialog>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { fail, wait, success } from '@/assets/json/index'
import { mapActions } from 'vuex'
import { mockHrefJump, judgeClientSystem, getKey } from '../../../assets/utils'
import Lottie from 'vue-lottie'
import common from './components/common.vue'
export default {
  name: 'repayment-consult-result',
  customReadyNotify: true,
  components: {
    'lottie': Lottie,
    common
  },

  data () {
    return {
      showGif: null,
      serviceVisible: false,
      repayResult: {},
      loanPlatform: this.$route.query.loanPlatform || 'TMD',
      applySerialNo: this.$route.query.applySerialNo,
      animationSpeed: 1,
      timer: null // 轮询
    }
  },

  async created () {
    try {
      await this.getRepayResult()
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },
  computed: {
    // 还款信息
    repaymentBill () {
      const { repaymentBill } = this.repayResult
      return repaymentBill || {}
    },
    // 借款信息
    loanBill () {
      const { loanBill } = this.repayResult
      return loanBill || {}
    },
    platform () {
      const platform = getKey('platform') || this.allPlatForm
      const result = platform && platform.find(item => item.loanPlatform === this.loanPlatform)
      if (result) {
        return {
          name: result.loanPlatformName,
          icon: result.iconUrl
        }
      }
      return {
        name: platform && platform['TMD'] && platform['TMD'].loanPlatformName,
        icon: platform && platform['TMD'] && platform['TMD'].iconUrl
      }
    },
    showDetail () {
      const { loanStatus } = this.repayResult || {}
      if (['LOANING'].includes(loanStatus)) {
        return {
          name: '协商还款中',
          des: [
            '您的申请已提交，请耐心等待'
          ],
          buttonTitle: '返回首页',
          showIphone: false,
          showList: false 
        }
      } else if (['APPLY_FAIL', 'LOAN_FAILURE'].includes(loanStatus)) {
        return {
          name: '协商还款失败',
          des: [
            '抱歉，本次协商还款失败，请您稍后重新发起；',
            '如有疑问，联系客服'
          ],
          buttonTitle: '返回首页',
          showIphone: true,
          showList: false 
        }
      } else if (loanStatus === 'LOAN_PASSED') {
        return {
          name: '协商还款成功',
          des: [
            '恭喜协商还款成功，订单状态稍后更新，请留意查看 '
          ],
          buttonTitle: '返回首页',
          showIphone: false,
          showList: true 
        }
      } else {
        return {}
      }
    }
  },
  methods: {
    ...mapActions('repay', ['getRepayStatusX', 'consultResult']),

    handleAnimation (anim) {
      this.anim = anim
    },
    // 开始引导
    async startLeading () {
      this.downloadApp()
    },
    // 下拉刷新
    pulldown () {
      window.location.reload()
    },
    openCallDialog () {
      const { loanStatus } = this.repayResult || {}
      this.$report({
        id: 10059, 
        args: {
          position: loanStatus
        }
      })
      this.serviceVisible = true
    },

    async refresh () {
      await this.getRepayResult()
      return true
    },

    async getRepayResult () {
      const params = {
        applySerialNo: this.applySerialNo
      }
      const response = await this.consultResult(params)
      if (response.success) {
        this.repayResult = response.data || {}
        this.changeGif(this.repayResult.loanStatus || 'LOANING')
        const mapping = {
          'LOANING': 2,
          'APPLY_FAIL': 3,
          'LOAN_FAILURE': 3,
          'LOAN_PASSED': 1
        }
        this.$report({
          id: 10105,
          args: {
            position: this.loanPlatform,
            status: mapping[this.repayResult.loanStatus]
          }
        })
      }
    },
    // 改变图片
    changeGif (value) {
      let title = {}
      if (['LOAN_PASSED'].includes(value)) {
        title = { animationData: success, loop: false }
      } else if (['APPLY_FAIL', 'LOAN_FAILURE'].includes(value)) {
        title = { animationData: fail, loop: false }
      } else if (value === 'LOANING') {
        title = { animationData: wait }
      }
      this.$nextTick(() => {
        this.showGif = title
      })
    },
    closeDialog () {
      this.$report({
        id: 10062, 
        args: {
          postion: 'page_repayment_consult_result'
        }
      })
    },

    callService () {
      const { loanStatus } = this.repayResult || {}
      // 点击客服弹框确定按钮
      this.$report({
        id: 10061, 
        args: {
          position: 'page_repayment_consult_result',
          status: loanStatus, 
          target: this.repayResult.tel
        }
      })
      mockHrefJump(`tel:4000100008`)
    },
    back () {
      // 如果是在app内就直接退出
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.push('/')
      }
    }
  }, 
  watch: {
    'repayResult.loanStatus' (value, value1) {
      if (value === 'LOANING') {
        this.timer = setInterval(() => {
          this.getRepayResult()
        }, 10000)
      } else {
        if (this.timer) {
          window.location.reload()
          clearInterval(this.timer)
        }
      }
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less">
@import "../../../assets/less/mixin.less";

.page{
    height:100%;
}
</style>
<style lang='less' scoped>
@import "../../../assets/less/mixin.less";

.repay-result {
    height: 100%;
    .pull{
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: scroll;
    }
    .repay-status{
        flex:1;
        margin-top:50px;
        text-align: center;
        .animation-wapper {
            height: 140px;
            width: 140px;
            margin: 0 auto;
        }
        .status-title{
            margin-top:27px;
            font-size: 36px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 50px;
        }
        .status-description{
            margin-top:17px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 37px;
            margin-bottom:30px;
        }
        .bill-info{
            width: 690px;
            background: #FAFAFA;
            border-radius: 20px;
            margin:20px auto 0;
            padding:30px 30px 30px 40px;
            text-align:left;
            .item{
                margin-top:14px;
                display:flex;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 40px;
                .title{
                    width:180px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 40px;
                }
            }
        }
        .btn{
            margin:90px auto 0;
            width: 320px;
            height: 80px;
            border-radius: 40px;
            border: 2px solid #FF4633;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF4633;
            line-height: 45px;
            background:white;
        }
    }
    .xia-zai{
        display: block;
        width: 670px;
        height: 140px;
        margin:60px auto 60px;
    }
    .call {
        display: flex;
        justify-content:space-between;
        align-items: center;
        margin:50px auto 0;
        width: 200px;
        height: 60px;
        background: #FAFAFA;
        border-radius: 40px;
        border: 1px solid #EEEEEE;
        padding:0 23px 0 28px;
        img{
            width: 29px;
            height:29px;
        }
        >span{
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 37px;
        }
    }
    .service-dialog {
        padding: 10px 48px 80px;
        font-family: PingFangSC-Regular,PingFang SC;
        .title {
            font-size: 42px;
            height: 72px;
            line-height: 72px;
            font-family: PingFangSC-Semibold,PingFang SC;
            font-weight: 600;
        }
        .description {
            font-size: 30px;
            height: 32px;
            line-height: 32px;
            margin-top: 22px;
            font-weight: 400;
        }
        .description1{
                font-size: 30px;
                height: 32px;
                line-height: 32px;
                margin: 12px auto 12px;
                font-weight: 400;
            }
        .telphone {
            font-size: 24px;
            height: 40px;
            line-height: 40px;
            margin-top: 2px;
            font-weight: 400;
            color: @fc3;
        }
    }
}
</style>